/* eslint-disable react/no-array-index-key */
/* eslint-disable react/no-unstable-nested-components */
import React from 'react';
import SliderWrapper from '@ecs/tng-common/components/slider-wrapper/SliderWrapper';
import Image from '@ecs/tng-common/components/image/Image';
import { ifMobile, scrollTo } from '@ecs/tng-common/scripts/helpers';
import { Link } from 'gatsby';
import { placeholderDarker } from '@ecs/tng-common/scripts/media';
import ByLine from './ByLine';
import { themes, IPost } from '../helpers/interfaces';
import { returnTexturedClass, returnThemeBg } from '../helpers/functions';
import ROUTES from '../helpers/routes';
import placeholderImg from '../../static/graphics/social-experian-generic.svg';

export const featuredPostsLimit = 9;
type FeaturedPostsProps = {
  content: IPost[];
  heading: string;
  postsPerSlider?: number;
  className?: string;
  theme: themes;
  textured?: boolean;
  toHideAuthor?: boolean;
  toHideCategory?: boolean;
};

export default class FeaturedPosts extends React.Component<FeaturedPostsProps> {
  defaultNumberOfPosts = this.props.postsPerSlider || 3;

  splitPostsByChunks(array: IPost[], n: number) {
    const cache = [];
    const tmp = [...array];
    while (tmp.length) cache.push(tmp.splice(0, n));
    return cache;
  }

  returnPost(article: IPost, index: number) {
    const { toHideAuthor, toHideCategory } = this.props;
    const articleImageAlt = article?.expPostContent?.featImg?.alt || 'Illustration.';
    return (
      <div
        className="d-flex flex-wrap col px-md-3 px-xl-4 position-relative"
        key={`${article.databaseId}-art-slider-${index}`}>
        <Link
          to={ROUTES.BLOG.toUrl(article.uri ?? '')}
          className={`post-link-${this.props.theme} w-100 ${this.props.theme === 'dark' ? 'text-white' : 'text-dark'}`}>
          <div className="rounded-3 mb-md-2 overflow-hidden featured-img">
            <div
              aria-hidden="true"
              className="post-link-overlay"
            />
            <Image
              alt={articleImageAlt}
              src={
                article.expPostContent?.featImg?.srcWebP ||
                article.expPostContent?.featImg?.src ||
                placeholderImg
              }
              placeholder={placeholderDarker}
              height="88"
              width="88"
              lazyLoading
            />
          </div>

          <h3 className="h5">
            <span className="post-link-title">{article.title}</span>
          </h3>
        </Link>
        <ByLine
          className="align-self-md-end"
          theme={this.props.theme}
          date={article.date}
          category={toHideCategory ? undefined : article.categories?.nodes[0]}
          databaseId={article.databaseId}
          author={toHideAuthor ? undefined : article.author?.node}
          isAuthorLink={false}
          authorImgLazyLoading
        />
      </div>
    );
  }

  render() {
    const articlesArray = this.props?.content?.slice(0, 3 * this.defaultNumberOfPosts);
    return (
      <section
        className={`${this.props.className || ''} featured-posts featured-posts-${this.props.theme} ${returnTexturedClass(this.props.theme, this.props.textured)} ${returnThemeBg(this.props.theme)}`}
        id="featured-posts">
        <div className="container container-py">
          <h2 className="content-mb">{this.props.heading}</h2>
          {articlesArray.length > this.defaultNumberOfPosts ? (
            <div className="row gx-lg-6 gx-xl-7">
              <div className="col-12 px-lg-1">
                <SliderWrapper
                  settings={{
                    lazyLoad: undefined,
                    afterChange: () => {
                      if (ifMobile()) {
                        scrollTo('featured-posts');
                      }
                    }
                  }}>
                  {this.splitPostsByChunks(articlesArray, this.defaultNumberOfPosts).map(
                    (art, i) => (
                      <React.Fragment key={`${i}-art-slider-wrp`}>
                        {art.map((article, index) => this.returnPost(article, index))}
                      </React.Fragment>
                    )
                  )}
                </SliderWrapper>
              </div>
            </div>
          ) : (
            <div className="row row-cols-1 row-cols-md-3 gx-0 gx-md-5">
              {articlesArray.map((article, index) => this.returnPost(article, index))}
            </div>
          )}
        </div>
      </section>
    );
  }
}
